import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth, db } from '../../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { LoadingContainer } from './PrivateRoute.styles';

const PrivateRoute = ({ children, roles }) => {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        } else {
          setUserRole('guest');
        }
      } else {
        setUserRole('guest');
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <LoadingContainer>Loading...</LoadingContainer>;
  }

  if (!roles.includes(userRole)) {
    return <Navigate to="/login" />;
  }

  // --- THIS IS THE FIX ---
  // Instead of calling children as a function, just render it.
  return children;
};

export default PrivateRoute;